import { render, staticRenderFns } from "./edit-problem.vue?vue&type=template&id=753aba5c&scoped=true"
import script from "../../assets/ts/monthly-summary/edit-problem.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/monthly-summary/edit-problem.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-problem.vue?vue&type=style&index=0&id=753aba5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753aba5c",
  null
  
)

export default component.exports